import { createClient } from '@supabase/supabase-js';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const SUPABASE_URL = 'https://vkdwegxoywhqwvdxhacg.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZrZHdlZ3hveXdocXd2ZHhoYWNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUxNTAxOTMsImV4cCI6MjA5MDcyNjE5M30.WG3eS-HFy6eNheyumeFYeBXdpJTmx_TBbjc5LsHOpDA';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Save a new gift (called when introducer submits the form)
export async function createGift(profile, purchaseToken) {
  const response = await fetch('/api/create-gift', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ profile, purchaseToken }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to save gift');
  }

  return data;
}

// Load a gift by its unique link ID (called when recipient opens their link)
export async function getGiftByLinkId(linkId) {
  if (!UUID_REGEX.test(linkId)) {
    throw new Error('Invalid gift link ID');
  }

  const response = await fetch('/api/open-gift', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ linkId }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Gift not found');
  }

  return data.gift;
}

// Save conversation messages and generated prompt
export async function saveConversation(giftId, messages, generatedPrompt) {
  const { data, error } = await supabase
    .from('conversations')
    .insert([{
      gift_id: giftId,
      messages: messages,
      generated_prompt: generatedPrompt,
      completed: true,
    }])
    .select()
    .single();

  if (error) throw error;
  return data;
}

// Save emoji reaction and feedback
export async function saveFeedback(conversationId, emoji, feedback) {
  const { error } = await supabase
    .from('conversations')
    .update({
      emoji_reaction: emoji,
      feedback: feedback || null,
    })
    .eq('id', conversationId);

  if (error) throw error;
}
